<!--
 * @description: 商品列表
 * @Author: Jay
 * @Date: 2021-09-25 09:07:21
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-12 10:19:25
-->
<template>
  <div>
    <div class="goods">
      <div v-class="'animate__animated animate__fadeInUp'">
        <div class="padding">
          <!-- 主标题 -->
          <div class="font_size_xl text-black font_weight_bold">
            {{ title }}
          </div>
          <!-- 副标题 -->
          <div class="font_size_sm text-gray margin-top-sm">{{ name }}</div>
        </div>
      </div>
      <!-- 商品区域 -->
      <div v-class="'animate__animated animate__fadeInUp'">
        <div class="flex padding-left padding-right">
          <div class="left-code">
            <ul class="text-gray" v-for="(item, index) in tabList" :key="index">
              <li
                class="tab-box font_size_xl"
                :class="tabIndex == index ? 'text-red' : ''"
                @click="selsecTap(index)"
              >
                <span class="text-red" v-show="tabIndex == index">
                  0{{ index + 1 }}
                </span>
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="right-code">
            <goode-right-list
              :goodsData="tabList"
              :tabIndex="tabIndex"
            ></goode-right-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goodeRightList from "./goods-right-liet.vue";
export default {
  name: "goodsCode",
  props: {
    title: {
      type: String,
      require: true,
    },
    name: {
      type: String,
      require: true,
    },
    tabList: {
      // type: Array,
      require: true,
    },
    tabID: {
      // type: Array,
      require: true,
    },
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  components: {
    goodeRightList,
  },
  methods: {
    //切换商品
    selsecTap(index) {
      this.tabIndex = index;
    },
  },
  watch: {
    // 监听
    tabID(newval) {
      // console.log("监听", newval);
      // console.log("长度", this.tabList.length);
      if (this.tabList.length - 1 >= newval) {
        this.tabIndex = newval;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 图片背景
.goods {
  background: #fafafa url("../../assets/bg-goods.png") no-repeat right 8.177vw;
  background-size: 54.688vw 43.49vw;
}
//左边
.left-code {
  width: 310px;
  background-color: #fafafa;
  li {
    list-style: none;
    //鼠标事件
    cursor: default;
  }
}
//左边 tab
.tab-box {
  height: 79px;
}
.right-code {
  flex: 1;
  height: 510px;
  // background-color: aquamarine;
}
</style>